export { epic } from './epic'
export { default } from './reducer'



// WEBPACK FOOTER //
// ./src/modules/profile/index.js